import { MOBILE, DESKTOP } from './Placeholder';

export const deviceDetect = () => {
  let device = DESKTOP;
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
      navigator.userAgent,
    )
  ) {
    device = MOBILE;
  }
  return device;
};
